import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Transaction } from "../../types/transaction.type";
import { Menu, message, Table, Typography } from "antd";
import { api } from "../../api/api";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

const { Title } = Typography;

export default function CashTransferPayments() {
  const { name, id } = useParams();
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/cashbox/all/transactions`, {
        params: {
          page,
          limit: pageSize,
          cashTransferId: id,
        },
      });
      setTransactions(response.data.transactions);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Ошибка получение транзакций", error);
      message.error("Ошибка получение транзакций");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [page, pageSize, id]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },

    {
      title: "Касса",
      dataIndex: "cashboxName",
      key: "cashboxName",
    },
    {
      title: "Кассир",
      dataIndex: "cashierName",
      key: "cashierName",
    },
    {
      title: "Описанине",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Баланс до",
      dataIndex: "balanceBefore",
      key: "balanceBefore",
      render: (data: number) => roundToThreeDecimals(data),
    },
    {
      title: "Баланс после",
      dataIndex: "balanceAfter",
      key: "balanceAfter",
      render: (data: number) => roundToThreeDecimals(data),
    },
    {
      title: "Сумма",
      dataIndex: "amount",
      key: "amount",
      render: (amount: number) => roundToThreeDecimals(amount),
    },
    {
      title: "Курс",
      dataIndex: "exchangeRate",
      key: "exchangeRate",
    },
    {
      title: "Тип",
      dataIndex: "type",
      key: "type",
    },
  ];
  
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Выплаты {name}</Title>

      <Table
        columns={columns}
        dataSource={transactions}
        loading={loading}
        rowKey="_id"
        pagination={{
          current: page,
          pageSize,
          total,
          onChange: (page, pageSize) => {
            setPage(page);
            setPageSize(pageSize);
          },
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
